(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["denilo-advertisement"] && !Shopify.designMode) return;
  try {
    (()=>{const slot=document.querySelector('.dnl-advertisement .adsbygoogle');if(!slot)return;let requested=false;const request=()=>{if(requested)return;const privacy=window.Shopify?.customerPrivacy;if(!privacy||!privacy.marketingAllowed()||!privacy.saleOfDataAllowed())return;requested=true;(window.adsbygoogle=window.adsbygoogle||[]).push({});};document.addEventListener('visitorConsentCollected',request);if(window.Shopify?.loadFeatures)window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],error=>{if(!error)request();});})();
  } catch(e) { console.error(e); }
})();

})();
